import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { SiteLayout } from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import EditorialPage from "@/pages/EditorialPage";
import AboutPage from "@/pages/AboutPage";
import ResearchPage from "@/pages/ResearchPage";
import ResearchArticlePage from "@/pages/ResearchArticlePage";
import StrategyPage from "@/pages/StrategyPage";
import StrategyArticlePage from "@/pages/StrategyArticlePage";
import SavedResearchPage from "@/pages/SavedResearchPage";
import LegalPage from "@/pages/LegalPage";

const pageData = {
  research: {
    eyebrow: "Research", title: "Independent inquiry into enduring businesses.",
    intro: "Company research grounded in primary sources, careful context and a long-term view of value creation.",
    categories: ["Company Research", "Industry Structure", "Competitive Advantage", "Original Essays"],
    note: "The research archive is currently in development. No publications have been released yet.",
  },
  strategy: {
    eyebrow: "Strategy", title: "Clear frameworks for consequential decisions.",
    intro: "A working collection of strategic models, decision principles and observations on how durable advantage is built.",
    categories: ["Strategic Frameworks", "Decision-Making", "Capital Allocation", "Long-Term Thinking"],
    note: "Strategy notes and frameworks are being prepared for future publication.",
  },
  projects: {
    eyebrow: "Projects", title: "Practice, documented with rigour.",
    intro: "Project studies, tactical notes and personal experiments examined for what they reveal about execution and value.",
    categories: ["Case Studies", "Personal Projects", "Tactical Notes", "Lessons in Execution"],
    note: "The project archive is currently being assembled. Studies will be added as they are completed.",
  },
};

export const ProjectsSourcePage = () => <EditorialPage {...pageData.projects} />;

export function AppRoutes() {
  return <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/research/:slug" element={<ResearchArticlePage />} />
          <Route path="/strategy" element={<StrategyPage />} />
          <Route path="/strategy/:slug" element={<StrategyArticlePage />} />
          <Route path="/saved" element={<SavedResearchPage />} />
          <Route path="/projects" element={<Navigate to="/research" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/legal/disclaimer" element={<LegalPage documentKey="disclaimer" />} />
          <Route path="/legal/privacy-policy" element={<LegalPage documentKey="privacy" />} />
          <Route path="/legal/terms-of-use" element={<LegalPage documentKey="terms" />} />
        </Route>
      </Routes>;
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
